var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_5881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 19.1667C16.4927 19.1667 19.3332 16.3262 19.3332 12.8333C19.3332 9.3405 16.4927 6.5 12.9998 6.5C9.507 6.5 6.6665 9.3405 6.6665 12.8333C6.6665 16.3262 9.507 19.1667 12.9998 19.1667ZM12.9998 9.66667C14.7463 9.66667 16.1665 11.0869 16.1665 12.8333C16.1665 14.5798 14.7463 16 12.9998 16C11.2534 16 9.83317 14.5798 9.83317 12.8333C9.83317 11.0869 11.2534 9.66667 12.9998 9.66667Z",
    fill: "#2091F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7485 31.5392C12.0164 31.7305 12.3375 31.8334 12.6668 31.8334C12.9961 31.8334 13.3172 31.7305 13.5851 31.5392C14.0665 31.1987 25.3794 23.0303 25.3335 12.8337C25.3335 5.84958 19.6509 0.166992 12.6668 0.166992C5.68272 0.166992 0.000139393 5.84958 0.000139393 12.8257C-0.0457773 23.0303 11.2671 31.1987 11.7485 31.5392ZM12.6668 3.33366C17.9061 3.33366 22.1668 7.59441 22.1668 12.8416C22.2001 19.8684 15.2191 26.178 12.6668 28.2474C10.1161 26.1764 3.13356 19.8652 3.16681 12.8337C3.16681 7.59441 7.42756 3.33366 12.6668 3.33366Z",
    fill: "#2091F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_5881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps2);
export default __webpack_public_path__ + "static/media/maps2.b40395d66ffa5d9c913ab78ce2906c7c.svg";
export { ForwardRef as ReactComponent };